export default "__VITE_ASSET__uSbT1KPP__"